import { Link } from 'react-router-dom'
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { Btn, H4, Image, P } from '../../../AbstractElements'
import { AlreadyHaveAnAccount, AuthSignIn, Unlock } from '../../../Constant'
import { useState } from 'react'
import { dynamicImage } from '../../../Service/DynamicImage'

const UnlockUserContainer = () => {
  const [show,setShow]= useState(false)
  
  return (
    <Container fluid className="p-0">
      <div className="authentication-main mt-0">
        <Row>
          <Col sm="12">
            <div className="login-card login-dark">
              <div>
                <div><Link className="logo" to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                  <Image className="img-fluid for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage"/>
                  <Image className="img-fluid for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage"/></Link></div>
                <div className="login-main">
                  <Form className="theme-form">
                    <H4>{Unlock}</H4>
                    <FormGroup>
                      <Label className='col-form-label'>Enter your Password</Label>
                      <div className="form-input position-relative">
                        <Input type={show? "text" :"password"} required placeholder="*********"/>
                        <div className="show-hide" onClick={()=>setShow(!show)}><span className="show"></span></div>
                      </div>
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <div className="checkbox p-0">
                        <Input id="checkbox1" type="checkbox"/>
                        <Label className="text-muted" htmlFor="checkbox1">Remember password</Label>
                      </div>
                      <Btn color='primary' className="btn-block w-100">{Unlock}</Btn>
                    </FormGroup>
                    <P className="mt-4 mb-0">{AlreadyHaveAnAccount}<Link className="ms-2" to={`${process.env.PUBLIC_URL}/auth/login`}>{AuthSignIn}</Link></P>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
      </Row>
      </div>
    </Container>
  )
}

export default UnlockUserContainer